"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Facilities;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Facilities(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "facilities-2",
    "data-name": "facilities"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-4",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M50,30A40.743,40.743,0,0,0,21,42.013a2.5,2.5,0,0,0,3.535,3.536,36.006,36.006,0,0,1,50.921,0,2.5,2.5,0,1,0,3.535-3.535A40.733,40.733,0,0,0,50,30Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M91.768,29.241a59.069,59.069,0,0,0-83.536,0,2.5,2.5,0,0,0,3.536,3.536,54.068,54.068,0,0,1,76.464,0,2.5,2.5,0,1,0,3.536-3.535Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M33.774,54.785a2.5,2.5,0,0,0,3.536,3.536,17.964,17.964,0,0,1,25.376,0,2.5,2.5,0,0,0,3.535-3.535A22.971,22.971,0,0,0,33.774,54.785Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M50.368,66.47h-5.99a1.5,1.5,0,0,0-1.5,1.5V84.022a1.5,1.5,0,0,0,3,0V77.884h4.769a8.458,8.458,0,0,0,3.514-.641,5.066,5.066,0,0,0,2.961-4.91,5.571,5.571,0,0,0-1.688-4.216A7.255,7.255,0,0,0,50.368,66.47Zm2.547,8.043a5.713,5.713,0,0,1-2.27.371H45.878V69.47h4.537c.037,0,.074,0,.111,0a4.469,4.469,0,0,1,2.867.849,2.6,2.6,0,0,1,.729,2.018A2.056,2.056,0,0,1,52.915,74.513Z"
  })))));
}